<template>
  <div class="container" id="SearchAza">
    <div id="Filters" class="pr-3 p-2 mr-2 ml-2 mb-3 row">
      <div class="row col-12">
        <div id="ShomareOzv" class="col-md-3 col-12 mt-2">
          <small>کد مشتری</small>
          <input type="text" v-mask="$session.get('UserInfo').codeShobe.trim() + '-########'" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" class="form-control" dir="ltr" v-model="DataAxiosSerch.ArryfildValue.ShomareOzv" />
        </div>
        <div id="CodeMeli" class="col-md-3 col-12 mt-2">
          <small>کد ملی </small>
          <input type="text" v-mask="'##########'" maxlength="10" @keypress="$ValidNumber($event, 10)" @input="$CheckupLengthCodeMeli($event)" class="form-control required-CodeMeli text-left" v-model="DataAxiosSerch.ArryfildValue.CodeMeli" />
        </div>
        <div id="OzvName" class="col-md-3 col-12 mt-2">
          <small> نام </small>
          <input type="text" class="form-control" v-model="DataAxiosSerch.ArryfildValue.OzvName" />
        </div>
        <div id="OzvFamily" class="col-md-3 col-12 mt-2">
          <small> نام خانوادگی </small>
          <input type="text" class="form-control" v-model="DataAxiosSerch.ArryfildValue.OzvFamily" />
        </div>
        <div id="Mobile" class="col-md-3 col-12 mt-2">
          <small>تلفن همراه </small>
          <input type="text" dir="ltr" v-mask="'09#########'" placeholder="09_________" @keypress="$ValidNumber($event, 11)" class="form-control" v-model="DataAxiosSerch.ArryfildValue.Mobile" />
        </div>
        <div id="Shenasname" class="col-md-3 col-12 mt-2">
          <small>شماره شناسنامه </small>
          <input type="text" dir="ltr" v-mask="'##########'" class="form-control" v-model="DataAxiosSerch.ArryfildValue.Shenasname" />
        </div>
        <div class="col-md-6 pt-3">
          <button class="btn btn-success w-100 mt-4" @click="Search()"><i class="fa fa-search"></i> جستوجوی مشتری</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 p-3">
        <BnpGrid :key="gridkey" :action="true" :propsColumn="columns" :propsRows="rows">
          <template slot="action-slot" slot-scope="props">
            <a href="#" class="badge badge-warning font-weight-normal p-1 m-1" data-dismiss="modal" @click="OnDetail(props.props)">انتخاب</a>
          </template>
          <template slot="action-slot2"> </template>
          <template slot="empty-results"> برای مشاهده حساب ها / مشتریان جستجو انجام دهید </template>
        </BnpGrid>
      </div>
    </div>
  </div>
</template>

<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      gridkey: 0,
      columns: [
        {
          id: 101796,
          name: 'OzvName',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'نام',
          sort: false,
        },
        {
          id: 101797,
          name: 'OzvFamily',
          visibility: true,
          width: 0,
          indexCol: 1,
          label: 'نام خانوادگي',
          sort: false,
        },
        {
          id: 100914,
          name: 'ShomareOzv',
          visibility: true,
          width: 0,
          indexCol: 2,
          label: 'كد مشتري',
          sort: false,
        },
        {
          id: 100925,
          name: 'Shenasname',
          visibility: true,
          width: 0,
          indexCol: 4,
          label: 'شماره شناسنامه',
          sort: false,
        },
        {
          id: 100926,
          name: 'Mobile',
          visibility: false,
          width: 0,
          indexCol: 9,
          label: 'همراه',
          sort: false,
        },
        {
          id: 100918,
          name: 'CodeMeli',
          visibility: false,
          width: 0,
          indexCol: 11,
          label: 'كد ملی',
          sort: false,
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      rows: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: true,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        selected_rows_info: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
          multi_column_sort: true,
        },
      },
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmVorodi',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxiosSerch: {
        ArryfildValue: {
          ShomareOzv: '',
          OzvFamilyName: '',
          Mobile: '',
          CodeMeli: '',
          Shenasname: '',
          OzvFamily: '',
          OzvName: '',
          Parvandeh: '',
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm',
      },
    }
  },
  components: {
    BnpGrid,
  },
  mounted() {
    console.log('SEARCH AZA MOUNTED')
    //   this.columns = this.$NewGridColumns(this.DataAxoisColumns, true, false, false, true);
    //   console.log("XXX",this.columns);
  },
  created() {
    console.log('CREATED')
  },
  methods: {
    OnDetail(row) {
      this.$emit('OzvSelected', row)
      this.$mySweetDefaultTost('عضو مورد نظر انتخاب شد', '', 'success', 1500)
    },
    Search() {
      try {
        this.DataAxiosSerch.ArryfildValue.TblGrpId = this.$session.get('UserInfo').tblGrpId
        this.DataAxiosSerch.ArryfildValue.tblShobeId = this.$session.get('UserInfo').tblShobeId
        console.log(this.DataAxiosSerch.ArryfildValue.tblShobeId)
        this.DataAxiosSerch.Action = 'vorodi'
        this.DataAxiosSerch.Method = 'post'
        this.$PostData(this.DataAxiosSerch).then((data) => {
          if (data.length > 0) {
            this.posts = data
            if (this.posts != null) {
              this.rows = this.posts
              this.rows = this.$FormatMablaghGrid(this.rows)
              this.gridkey++
            }
          } else {
            this.rows = []
            this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 3000)
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style></style>
